import { JsonProperty, JsonObject } from 'typescript-json-serializer';

@JsonObject()
export class LmCurrent {
  @JsonProperty('CurrentL1') line1: number;
  @JsonProperty('CurrentL2') line2: number;
  @JsonProperty('CurrentL3') line3: number;
}
